import { inject, provide, ref } from "vue";
import { Mutex } from "async-mutex";
import { isStatusError, isValidationError } from "@/meta";
export function queryString(query) {
    const entries = Object.entries(query).filter((d) => d[1] !== undefined);
    return entries.length
        ? `?${entries.map((i) => `${i[0]}=${encodeURIComponent(i[1])}`).join("&")}`
        : "";
}
export function provideConfirmPasswordModal() {
    const confirmPasswordModal = ref(false);
    const savedResolveReject = ref();
    const showModal = () => {
        return new Promise((resolve, reject) => {
            savedResolveReject.value = { resolve, reject };
            confirmPasswordModal.value = true;
        });
    };
    const closeModal = (provided) => {
        confirmPasswordModal.value = false;
        const { resolve, reject } = savedResolveReject.value;
        if (provided)
            return resolve();
        return reject();
    };
    const cpm = {
        confirmPasswordModal,
        closeModal,
        showModal,
    };
    provide("confirmPasswordModal", cpm);
    return cpm;
}
export function useConfirmPasswordModal() {
    const cpm = inject("confirmPasswordModal");
    return {
        showConfirmModal: cpm?.showModal,
    };
}
export function useErrorHandling(showConfirmModal) {
    if (!(typeof showConfirmModal === "function")) {
        showConfirmModal = useConfirmPasswordModal().showConfirmModal;
    }
    const errors = ref({
        errors: {},
        message: "",
    });
    const handleError = async (err, retry) => {
        if (isStatusError(err)) {
            if (err.statusCode === 422) {
                const json = await err.json();
                if (isValidationError(json)) {
                    errors.value = json;
                }
            }
            else if (err.statusCode === 423 && retry) {
                try {
                    if (showConfirmModal) {
                        await showConfirmModal();
                    }
                }
                catch (e) {
                    console.warn("User declined entering password.");
                    return;
                }
                await retry();
            }
        }
    };
    return {
        errors,
        handleError,
    };
}
export function useFetch(callback) {
    const mutex = new Mutex();
    const loading = ref(false);
    const fetch = async (param1, param2) => {
        const release = await mutex.acquire();
        try {
            loading.value = true;
            const val = await callback(release, param1, param2);
            if (mutex.isLocked())
                release();
            loading.value = false;
            return val;
        }
        catch (err) {
            release();
            loading.value = false;
            throw err;
        }
    };
    return {
        loading,
        fetch,
    };
}
